import React, { useEffect, useState } from 'react';
import "./OrderInfo.css";
import { onAuthStateChanged } from 'firebase/auth';
import { auth, firestore } from '../../firebase/firebaseConfig';
import { getDoc, doc, getDocs, collection, query, where, updateDoc, addDoc, onSnapshot } from "@firebase/firestore";
import { useParams } from 'react-router-dom';
import { Button, Modal, Radio, message } from 'antd';

function OrderInfo ( props ) {
    let { docId } = useParams();
    let [ orderObject, setOrderObject ] = useState( {} );
    const [ open, setOpen ] = useState( false );
    const [ open2, setOpen2 ] = useState( false );
    const [ confirmLoading, setConfirmLoading ] = useState( false );
    const [ confirmLoading2, setConfirmLoading2 ] = useState( false );
    const [ paymentMethod, setPaymentMethod ] = useState( "wallet" );
    const [ wallet, setWallet ] = useState( 0 );
    const [ tip, setTip ] = useState( 0 );
    const [ messageApi, contextHolder ] = message.useMessage();

    async function onload ( user ) {
        onSnapshot( doc( firestore, "users/" + user.uid + "/user_orders", docId ), ( snapshot ) => {
            let delivery_date;
            if ( snapshot.data().delivery_within === "24 hrs" ) {
                delivery_date = new Date( snapshot.data().pickup_date.toDate().setDate( snapshot.data().pickup_date.toDate().getDate() + 1 ) )
            } else {
                delivery_date = new Date( snapshot.data().pickup_date.toDate().setDate( snapshot.data().pickup_date.toDate().getDate() + 5 ) )
            }

            let object = {
                cart: JSON.parse( snapshot.data().cart_items ),
                order_id: snapshot.data().order_id,
                pickup_date: snapshot.data().pickup_date.toDate().toLocaleString().split( "," )[ 0 ],
                delivery_method: snapshot.data().delivery_within === "24 hrs" ? "Express Delivery" : "Regular Delivery",
                delivery_date: delivery_date.toLocaleString().split( "," )[ 0 ],
                status: snapshot.data().status,
                express_delivery: snapshot.data().express_delivery,
                delivery_charge: snapshot.data().delivery_charge,
                delivery_tip: snapshot.data().delivery_tip,
                order_total: snapshot.data().order_total,
                timeslot: snapshot.data().timeslot
            }

            setOrderObject( object );
        } );


        onSnapshot( doc( firestore, "users/" + user.uid + "/wallet", "wallet_id" ), ( snapshot ) => {
            setWallet( snapshot.data().wallet_balance.toFixed( 2 ) );
        } )

        document.querySelector( ".loader-container" ).style.display = "none";
    }

    async function payNow ( event ) {
        let cancelOrderDocs = await getDocs( query( collection( firestore, "orders_temp/accepted_orders_id/accepted_orders" ), where( "order_doc", "==", docId ) ) );
        if ( paymentMethod === "wallet" ) {
            let checkDoc = await getDoc( doc( firestore, "users/" + auth.currentUser.uid + "/wallet", "wallet_id" ) );
            if ( parseFloat( checkDoc.data().wallet_balance ) >= parseFloat( parseFloat( orderObject.order_total ).toFixed( 2 ) ) ) {
                setConfirmLoading2( true );
                await updateDoc( doc( firestore, "users/" + auth.currentUser.uid + "/user_orders", docId ), {
                    status: "paid"
                } )
                await updateDoc( doc( firestore, "orders_temp/accepted_orders_id/accepted_orders", cancelOrderDocs.docs[ 0 ].id ), {
                    status: "paid"
                } )
                await updateDoc( doc( firestore, "users/" + auth.currentUser.uid + "/wallet", "wallet_id" ), {
                    wallet_balance: parseInt( wallet ) - parseFloat( parseFloat( orderObject.order_total ).toFixed( 2 ) )
                } )
                await addDoc( collection( firestore, "transaction_history_global" ), {
                    order_doc: docId,
                    amount: parseFloat( parseFloat( orderObject.order_total ).toFixed( 2 ) ),
                    order_total: parseFloat( parseFloat( orderObject.order_total ).toFixed( 2 ) ),
                    customer_name: props.details.name,
                    via: "LB Wallet",
                    order_id: orderObject.order_id,
                    customer_id: auth.currentUser.uid,
                    time: new Date(),
                    source: "website"
                } )
                await addDoc( collection( firestore, "users/" + auth.currentUser.uid + "/transaction_history" ), {
                    order_id: orderObject.order_id,
                    amount: "-Rs. " + parseInt( parseFloat( orderObject.order_total ).toFixed( 2 ) ),
                    timestamp: new Date(),
                    message: "Paid for Order ID " + orderObject.order_id,
                    method: "Payment to Laundry Buddy",
                    source: "website"
                } )
                setConfirmLoading2( false );
                setOpen2( false );
            } else {
                error();
            }
        } else if ( paymentMethod === "other" ) {
            setOpen2( false );
            var options = {
                "key": process.env.REACT_APP_RAZOR_KEY,
                "key_secret": process.env.REACT_APP_RAZOR_KEY_SECRET,
                "amount": ( parseInt( orderObject.order_total ) * 100 ).toString(),
                "currency": "INR",
                "name": "Laundry Buddy",
                "description": "Adding Money to LB Wallet",
                "image": btoa( require( "../../images/logo.webp" ) ),
                "handler": async function ( response ) {
                    await updateDoc( doc( firestore, "users/" + auth.currentUser.uid + "/user_orders", docId ), {
                        status: "paid"
                    } )
                    await updateDoc( doc( firestore, "orders_temp/accepted_orders_id/accepted_orders", cancelOrderDocs.docs[ 0 ].id ), {
                        status: "paid"
                    } )
                    await addDoc( collection( firestore, "transaction_history_global" ), {
                        order_doc: docId,
                        amount: parseFloat( parseFloat( orderObject.order_total ).toFixed( 2 ) ),
                        order_total: parseFloat( parseFloat( orderObject.order_total ).toFixed( 2 ) ),
                        customer_name: props.details.name,
                        via: "RazorPay",
                        order_id: orderObject.order_id,
                        customer_id: auth.currentUser.uid,
                        time: new Date(),
                        source: "website"
                    } )
                    await addDoc( collection( firestore, "users/" + auth.currentUser.uid + "/transaction_history" ), {
                        order_id: orderObject.order_id,
                        amount: "-Rs. " + parseInt( parseFloat( orderObject.order_total ).toFixed( 2 ) ),
                        timestamp: new Date(),
                        message: "Paid for Order ID " + orderObject.order_id,
                        method: "Payment to Laundry Buddy",
                        source: "website"
                    } )
                },
                "prefill": {
                    "name": props.details.name, //your customer's name
                    "email": props.details.email,
                    "contact": props.details.phone
                },
                "theme": {
                    "color": "#3399cc"
                }
            };
            var rzp1 = new window.Razorpay( options );
            rzp1.on( 'payment.failed', function ( response ) {
                console.log( response );
            } );
            rzp1.open();
        }
    }

    async function tipPartner ( event ) {
        if ( paymentMethod === "wallet" ) {
            let checkDoc = await getDoc( doc( firestore, "users/" + auth.currentUser.uid + "/wallet", "wallet_id" ) );
            if ( parseFloat( checkDoc.data().wallet_balance ) >= parseInt( tip ) ) {
                setConfirmLoading( true );
                await updateDoc( doc( firestore, "users/" + auth.currentUser.uid + "/wallet", "wallet_id" ), {
                    wallet_balance: parseInt( wallet ) - parseInt( tip )
                } )
                await addDoc( collection( firestore, "transaction_history_global" ), {
                    order_doc: docId,
                    amount: parseInt( tip ).toString(),
                    order_total: parseFloat( parseFloat( orderObject.order_total ).toFixed( 2 ) ),
                    customer_name: props.details.name,
                    via: "LB Wallet",
                    order_id: orderObject.order_id,
                    customer_id: auth.currentUser.uid,
                    time: new Date(),
                    source: "website"
                } )
                await addDoc( collection( firestore, "users/" + auth.currentUser.uid + "/transaction_history" ), {
                    order_id: orderObject.order_id,
                    amount: "-Rs. " + parseInt( tip ),
                    timestamp: new Date(),
                    message: "Delivery Tip for Order ID " + orderObject.order_id,
                    method: "Payment to Laundry Buddy",
                    source: "website"
                } )
                setConfirmLoading( false );
                setOpen( false );
            } else {
                error();
            }
        } else if ( paymentMethod === "other" ) {
            setOpen( false );
            var options = {
                "key": process.env.REACT_APP_RAZOR_KEY,
                "key_secret": process.env.REACT_APP_RAZOR_KEY_SECRET,
                "amount": ( parseInt( tip ) * 100 ).toString(),
                "currency": "INR",
                "name": "Laundry Buddy",
                "description": "Paying of Tip for Order ID " + orderObject.order_id,
                "image": btoa( require( "../../images/logo.webp" ) ),
                "handler": async function ( response ) {
                    await addDoc( collection( firestore, "transaction_history_global" ), {
                        order_doc: docId,
                        amount: parseInt( tip ).toString(),
                        order_total: parseFloat( parseFloat( orderObject.order_total ).toFixed( 2 ) ),
                        customer_name: props.details.name,
                        via: "RazorPay",
                        order_id: orderObject.order_id,
                        customer_id: auth.currentUser.uid,
                        time: new Date(),
                        source: "website"
                    } )
                    await addDoc( collection( firestore, "users/" + auth.currentUser.uid + "/transaction_history" ), {
                        order_id: orderObject.order_id,
                        amount: "-Rs. " + parseInt( tip ),
                        timestamp: new Date(),
                        message: "Delivery Tip for Order ID " + orderObject.order_id,
                        method: "Payment to Laundry Buddy",
                        source: "website"
                    } )
                },
                "prefill": {
                    "name": props.details.name, //your customer's name
                    "email": props.details.email,
                    "contact": props.details.phone
                },
                "theme": {
                    "color": "#3399cc"
                }
            };
            var rzp1 = new window.Razorpay( options );
            rzp1.on( 'payment.failed', function ( response ) {
                console.log( response );
            } );
            rzp1.open();
        }
    }

    const error = () => {
        messageApi.open( {
            type: 'error',
            content: 'There is insufficient balance in your LB Wallet.',
            style: {
                marginTop: "10%"
            }
        } );
    };

    function tipInput ( event, value ) {
        event.target.parentNode.childNodes.forEach( ( element ) => {
            element.classList.remove( "active" );
        } )
        event.target.classList.add( "active" );
        setTip( value );
    }

    useEffect( () => {
        document.title = "Laundry Buddy - Track Your Order | Order Details";
        document.querySelector( ".loader-container" ).style.display = "flex";
        onAuthStateChanged( auth, ( user ) => {
            if ( user ) {
                onSnapshot( doc( firestore, "users", user.uid ), ( snapshot ) => {
                    if ( snapshot.exists() ) {
                        props.settingDetails( {
                            name: snapshot.data().name,
                            phone: snapshot.data().mobile,
                            email: snapshot.data().email,
                            address: snapshot.data().address,
                            pincode: snapshot.data().pincode
                        } )
                        onload( user );
                    } else {
                        window.location.href = "/signup";
                    }
                } );
            } else {
                window.location.href = "/";
            }
        } )
    }, [] )

    return (
        <div className='order-info-container'>
            {contextHolder}
            <Modal
                title="Select the Payment Mode"
                style={{ width: "400px" }}
                open={open2}
                onOk={payNow}
                confirmLoading={confirmLoading2}
                onCancel={event => setOpen2( false )}
            >
                <Radio.Group name="paymentMode" defaultValue={"wallet"} style={{ display: "flex", flexDirection: "column", gap: "0.8rem" }} onChange={event => { setPaymentMethod( event.target.value ); }}>
                    <Radio value={"wallet"}>Wallet (upto 20% off)</Radio>
                    <Radio value={"other"}>Other Payment Methods</Radio>
                </Radio.Group>
            </Modal>
            <Modal
                title="Select the Payment Mode"
                style={{ width: "400px" }}
                open={open}
                onOk={tipPartner}
                confirmLoading={confirmLoading}
                onCancel={event => setOpen( false )}
            >
                <div className='modal-tip-container'>
                    <div onClick={event => tipInput( event, 10 )}>
                        Rs. 10
                    </div>
                    <div onClick={event => tipInput( event, 15 )}>
                        Rs. 15
                    </div>
                    <div onClick={event => tipInput( event, 20 )}>
                        Rs. 20
                    </div>
                    <div onClick={event => tipInput( event, 25 )}>
                        Rs. 25
                    </div>
                    <div onClick={event => tipInput( event, 30 )}>
                        Rs. 30
                    </div>
                    <div onClick={event => tipInput( event, 35 )}>
                        Rs. 35
                    </div>
                    <div onClick={event => tipInput( event, 50 )}>
                        Rs. 50
                    </div>
                    <div onClick={event => tipInput( event, 75 )}>
                        Rs. 75
                    </div>
                    <div onClick={event => tipInput( event, 100 )}>
                        Rs. 100
                    </div>
                    <div onClick={event => tipInput( event, 150 )}>
                        Rs. 150
                    </div>
                </div>
                <Radio.Group name="paymentMode" defaultValue={"wallet"} style={{ display: "flex", flexDirection: "column", gap: "0.8rem" }} onChange={event => { setPaymentMethod( event.target.value ); }}>
                    <Radio value={"wallet"}>Wallet (upto 20% off)</Radio>
                    <Radio value={"other"}>Other Payment Methods</Radio>
                </Radio.Group>
            </Modal>
            <h4 style={{ fontWeight: "700", color: "grey" }}>Order Details</h4>
            <h1 style={{ fontWeight: "700" }}>Check Out Your Order</h1>
            <div className='order-info-inner-container'>
                <div>
                    <div className='mobile'>
                        <div className={[ "pending", "in warehouse", "accepted", "paid", "completed" ].includes( orderObject.status ) ? 'status-item active' : 'status-item'}>
                            <span></span>
                            <span>Pick Up</span>
                        </div>
                        <div className={[ "pending", "in warehouse", "accepted", "paid", "completed" ].includes( orderObject.status ) ? 'status-item-between active' : 'status-item-between'}>
                        </div>
                        <div className={[ "in warehouse", "accepted", "paid", "completed" ].includes( orderObject.status ) ? 'status-item active' : 'status-item'}>
                            <span></span>
                            <span>In Ware House</span>
                        </div>
                        <div className={[ "in warehouse", "accepted", "paid", "completed" ].includes( orderObject.status ) ? 'status-item-between active' : 'status-item-between'}>
                        </div>
                        <div className={[ "accepted", "paid", "completed" ].includes( orderObject.status ) ? 'status-item active' : 'status-item'}>
                            <span></span>
                            <span>Invoice Generated</span>
                        </div>
                        <div className={[ "accepted", "paid", "completed" ].includes( orderObject.status ) ? 'status-item-between active' : 'status-item-between'}>
                        </div>
                        <div className={[ "paid", "completed" ].includes( orderObject.status ) ? 'status-item active' : 'status-item'}>
                            <span></span>
                            <span>Ready To Deliver</span>
                        </div>
                        <div className={[ "paid", "completed" ].includes( orderObject.status ) ? 'status-item-between active' : 'status-item-between'}>
                        </div>
                        <div className={[ "completed" ].includes( orderObject.status ) ? 'status-item active' : 'status-item'}>
                            <span></span>
                            <span>Delivered</span>
                        </div>
                    </div>
                    <div>
                        Order Id - {orderObject.order_id}
                    </div>
                    <div>
                        Pickup Date : <span>{orderObject.pickup_date}</span>
                    </div>
                    <div>
                        Pick Time : <span>{orderObject.timeslot}</span>
                    </div>
                    <div>
                        Delivery Method : <span>{orderObject.delivery_method}</span>
                    </div>
                    <div>
                        Delivery Date : <span>{orderObject.delivery_date}</span>
                    </div>
                    <div className='laptop'>
                        <div className={[ "pending", "in warehouse", "accepted", "paid", "completed" ].includes( orderObject.status ) ? 'status-item active' : 'status-item'}>
                            <span></span>
                            <span>Pick Up</span>
                        </div>
                        <div className={[ "pending", "in warehouse", "accepted", "paid", "completed" ].includes( orderObject.status ) ? 'status-item-between active' : 'status-item-between'}>
                        </div>
                        <div className={[ "in warehouse", "accepted", "paid", "completed" ].includes( orderObject.status ) ? 'status-item active' : 'status-item'}>
                            <span></span>
                            <span>In Ware House</span>
                        </div>
                        <div className={[ "in warehouse", "accepted", "paid", "completed" ].includes( orderObject.status ) ? 'status-item-between active' : 'status-item-between'}>
                        </div>
                        <div className={[ "accepted", "paid", "completed" ].includes( orderObject.status ) ? 'status-item active' : 'status-item'}>
                            <span></span>
                            <span>Invoice Generated</span>
                        </div>
                        <div className={[ "accepted", "paid", "completed" ].includes( orderObject.status ) ? 'status-item-between active' : 'status-item-between'}>
                        </div>
                        <div className={[ "paid", "completed" ].includes( orderObject.status ) ? 'status-item active' : 'status-item'}>
                            <span></span>
                            <span>Ready To Deliver</span>
                        </div>
                        <div className={[ "paid", "completed" ].includes( orderObject.status ) ? 'status-item-between active' : 'status-item-between'}>
                        </div>
                        <div className={[ "completed" ].includes( orderObject.status ) ? 'status-item active' : 'status-item'}>
                            <span></span>
                            <span>Delivered</span>
                        </div>
                    </div>
                </div>
                <div>
                    {( orderObject.cart ? orderObject.cart : [] ).map( ( element ) => (
                        <div>
                            <div>
                                {element.category}
                            </div>
                            <div>
                                Quantity - {element.count}
                            </div>
                            <div>
                                Rs. {element.price}
                            </div>
                        </div>
                    ) )}
                    <div style={{ flexDirection: "column", gap: "0", padding: "0 1rem" }}>
                        <div style={{ display: "flex", width: "100%", justifyContent: "space-between", borderBottom: "1px solid lightgrey", padding: "1rem 0 0.5rem" }}>
                            <span>Express Delivery</span>
                            <span>Rs. {orderObject.express_delivery}</span>
                        </div>
                        <div style={{ display: "flex", width: "100%", justifyContent: "space-between", borderBottom: "1px solid lightgrey", padding: "1rem 0 0.5rem" }}>
                            <span>Delivery Charge</span>
                            <span>Rs. {orderObject.delivery_charge}</span>
                        </div>
                        <div style={{ display: "flex", width: "100%", justifyContent: "space-between", borderBottom: "1px solid lightgrey", padding: "1rem 0 0.5rem" }}>
                            <span>Delivery Tip</span>
                            <span>Rs. {orderObject.delivery_tip}</span>
                        </div>
                        <div style={{ display: "flex", width: "100%", justifyContent: "space-between", borderBottom: "1px solid lightgrey", padding: "1rem 0 0.5rem", fontWeight: "700" }}>
                            <span>Total Amount</span>
                            <span>Rs. {orderObject.order_total}</span>
                        </div>
                    </div>
                    <div className='order-info-button-container' style={{ display: "flex", gap: "2rem" }}>
                        <Button style={{ width: "60%" }} onClick={event => setOpen( true )}>Tip Your Partner</Button>
                        {orderObject.status === "accepted" && <Button style={{ width: "40%" }} onClick={event => setOpen2( true )}>Pay Now</Button>}
                        {orderObject.status === "paid" && <Button style={{ width: "40%" }}>Paid</Button>}
                    </div>
                </div>
            </div>
        </div >
    )
}

export default OrderInfo